import type { ProjectParticipant } from '@/api/adapter/projectParticipants';
import { profileImageUrl } from '@/hooks/useProfile';
import { Avatar } from '@/components/ui';

export function TeamMemberCard({
  participant,
  isCurrentUser,
  roleName,
}: {
  participant?: ProjectParticipant;
  isCurrentUser?: boolean;
  roleName: string;
}) {
  const profile = participant?.profiles?.worker;
  return (
    <div className="elevation-xs flex flex-wrap items-center justify-between gap-[var(--spacing-14,28px)] rounded-[var(--radi-6,12px)] border border-[var(--base-border,#3d3d3d)] bg-[var(--base-surface-2,#231f1f)] px-[var(--spacing-12,24px)] py-[var(--spacing-8,16px)]">
      <div className="flex items-center gap-[var(--spacing-8,16px)]">
        <Avatar
          className="[&>div]:!h-[56px] [&>div]:!w-[56px]"
          size="lg"
          alt={
            profile?.name ??
            participant?.displayName ??
            (participant ? roleName : '-')
          }
          src={
            participant?.workerImage && participant?.profiles
              ? profileImageUrl(participant?.profiles.principalId, 'worker')
              : undefined
          }
        />
        <div className="flex flex-col items-start gap-[--spacing-3] text-lg">
          <p className="font-semibold text-[--text-dark-primary]">
            {profile?.name ??
              participant?.displayName ??
              (participant ? roleName : '-')}
          </p>
          <p className="font-normal text-[--text-dark-secondary]">{roleName}</p>
        </div>
      </div>
      {!participant ? (
        <p className="font-medium text-[--text-dark-secondary]">
          Waiting to Join
        </p>
      ) : isCurrentUser ? (
        <p className="font-medium text-[--state-brand-active]">You</p>
      ) : participant.contactEmail ? (
        <a
          href={'mailto:' + participant.contactEmail}
          className="break-all font-medium text-[--state-brand-active] hover:underline"
        >
          {participant.contactEmail}
        </a>
      ) : null}
    </div>
  );
}
